import { z } from "zod";

export const widgetGlobalSettingsSchema = z.object({
  // name: z.string().trim().nonempty({ message: "Name is required" }),
  // logo_url: z.string().trim().url({ message: "Logo URL must be a valid URL" }).optional(),
  greeting: z.string().trim().nonempty({ message: "Greeting is required" }),
});

export type WidgetGlobalSettingsForm = z.infer<typeof widgetGlobalSettingsSchema>;

export const widgetGlobalSettingsDefaultValues: WidgetGlobalSettingsForm = {
  // name: "",
  // logo_url: "",
  greeting: "",
};

export const dropzoneOptions = {
  maxFiles: 1,
  maxSize: 1 * 1024 * 1024,
  multiple: false,
  accept: {
    "image/*": [".jpg", ".jpeg", ".png", ".gif", ".webp", ".bmp", ".svg"],
  },
};
